import { ScrollArea } from "@mantine/core";
import { useState } from "react";
import useUserPageParams from "../../../../../hooks/useUserPageParams";
import { useContact, useWorkspaceMetricPreferences, useWorkspacePreferences } from "../../../../../hooks/QueryHooks";
import useWorkspaceStore from "../../../../../store/workspace/workspaceStore";
import UserToolbar from "../components/UserToolbar";
import UsersTable from "../components/UserActivityTable";
import UserTrendsContainer from "../components/UserTrendsContainer";

const UserActivity = () => {
  const { userId }: any = useUserPageParams();
  const [metric, setMetric] = useState<any>({ id: 3, name: "Last 30 days" });

  const handleMetricChange = (newMetric: any) => {
    if (newMetric.id !== metric.id) {
      setMetric(newMetric);
    }
  };

  const currentWorkspace = useWorkspaceStore((state) => state.workspace);

  const { data: contact }: any = useContact({
    workspaceId: currentWorkspace.id,
    contactId: userId,
    enabled: !!userId && !!currentWorkspace?.id,
  });

  const prefs: any = useWorkspacePreferences({
    workspaceId: currentWorkspace?.id,
    enabled: !!currentWorkspace?.id,
  });

  const metrics: any = useWorkspaceMetricPreferences({
    workspaceId: currentWorkspace?.id,
    enabled: !!currentWorkspace?.id,
  });

  return (
    <ScrollArea type="scroll" scrollHideDelay={500} h="calc(100vh - 90px)">
      <div className="p-3 pb-0">
        <UserTrendsContainer
          prefs={prefs}
          metrics={metrics?.data?.filter((m: any) => m.linked_entity === "users")}
          account={contact}
          currentWorkspace={currentWorkspace}
        />
      </div>
      <div className="p-3 pb-0">
        <div className="relative flex flex-col gap-4 border bg-white border-gray-200 flex-grow h-full overflow-hidden">
          <UserToolbar metric={metric} setMetric={handleMetricChange} />
          <div className="flex-grow overflow-auto h-full">
            <UsersTable
              metric={metric}
              workspaceId={currentWorkspace?.id}
            />
          </div>
        </div>
      </div>
    </ScrollArea>
  );
};

export default UserActivity;
